// Generated types for ActionOutputParameter
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { ActionParameterReadAPI, ActionParameterWriteAPI } from './actionparameter';
import { ActionParameterReadAPISchemaObject, ActionParameterWriteAPISchemaObject } from './actionparameter';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface ActionOutputParameterReadAPI extends ActionParameterReadAPI {
}

export interface ActionOutputParameterWriteAPI extends ActionParameterWriteAPI {
  item?: string;
  bound_to?: string[];
  /** The Action this output parameter belongs to. */
  owner_action?: string;
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const ActionOutputParameterReadAPISchema: z.ZodType<ActionOutputParameterReadAPI> = ActionParameterReadAPISchemaObject.extend({}).passthrough();

export const ActionOutputParameterWriteAPISchema: z.ZodType<ActionOutputParameterWriteAPI> = ActionParameterWriteAPISchemaObject.extend({
  item: z.string().optional(),
  bound_to: z.array(z.string()).optional(),
  owner_action: z.string().optional(),
}).passthrough();
